<template>
<div class="chapter">
<div class="inner_page">
<section class="dedication" epub:type="dedication">
<p>For Ian and Trish, whose support and encouragement meant so much.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1.vue?45b4e8a6